import { useLocation, useNavigate } from "react-router-dom";
import { Flex, Stack } from "@chakra-ui/react";
import { MdHome, MdInfo, MdNaturePeople, MdContactPage, MdArticle } from "react-icons/md";
import { IconType } from "react-icons/lib";

import { NavButton } from "../layout/NavButton";

const navItems: Array<{ label: string; icon: IconType; path: string }> = [
	{ label: "Home", icon: MdHome, path: "/" },
	{ label: "See It In Use", icon: MdNaturePeople, path: "/example-farms" },
	{ label: "News & Media", icon: MdArticle, path: "/news" },
	{ label: "About Us", icon: MdInfo, path: "/about-us" },
	{ label: "Contact Us", icon: MdContactPage, path: "/contact-us" },
];

export const Sidebar = (): JSX.Element => {
	const navigate = useNavigate();
	const { pathname } = useLocation();
	const segments = pathname.split("/");
	const currentPage = `/${segments[segments.length - 1]}`;

	const renderNavButton = (text: string, icon: IconType, path: string): JSX.Element => (
		<NavButton
			label={text}
			icon={icon}
			onClick={() => navigate(path)}
			aria-current={currentPage === path ? "page" : false}
		/>
	);

	return (
		<Flex as="section" minH="100vh" bg="bg-canvas">
			<Flex
				flex="1"
				bg="bg-surface"
				overflow="auto"
				boxShadow="sm"
				maxW={{ base: "full", sm: "xs" }}
				py={{ base: "6", sm: "8" }}
				px={{ base: "4", sm: "6" }}
			>
				<Stack justify="space-between" spacing="1">
					<Stack spacing={{ base: "5", sm: "6" }} shouldWrapChildren>
						<img src="gecologo.png" width="100%" alt="Geco" />
						<Stack spacing="1" marginTop="2em">
							{navItems.map((item) => renderNavButton(item.label, item.icon, item.path))}
						</Stack>
					</Stack>
				</Stack>
			</Flex>
		</Flex>
	);
};
